webpackJsonp([4730701496960],{

/***/ 378:
/***/ (function(module, exports) {

	module.exports = {"experience":[{"company":"2001 - Present: Owner, Leasing Solutions LLC","description":"Independent management consulting business, working with lease brokers and leasing companies in placing lease transactions with banks and other funding sources. Credit review and documentation preparation and assistance."},{"company":"1989 - 2001: ORIX Credit Alliance, Inc. Operations Manager, Branch Manager, Vice President, Rediscount, Orangeburg, NY and Paramus, NJ"},{"company":"1982 - 1989: Tilden Financial Corp., Roslyn Heights, New York Credit Manager and Vice President"},{"company":"1978 - 1982: Marketing representative for two independent leasing companies"},{"company":"1976 - 1978: Peoples National Bank of Rockland County, Monsey, New York Vice President and Loan Officer"},{"company":"1969 - 1976: National Bank Examiner, Comptroller of the Currency, the Administrator of National Banks"}],"achievements":[{"company":"National Equipment Finance Association (NEFA)","responsibilities":"Regional Planning and conference committee"},{"company":"National Association of Equipment Lease Brokers (NAELB)","responsibilities":"Membership Committee, Distance Learning Committee, Master Member Committee"},{"company":"Equipment Leasing and Finance Association (ELFA)","responsibilities":"Independent Leasing Company Committee member, Leasing Transaction Network Committee, company Representative"},{"company":"CLFP Foundation - Trustee/Director 1999-2003, 2005 - 2007","responsibilities":"Not-For-Profit Educational foundation established to administer the granting and retention of CLFP members.  One of five original trustees selected nationwide to establish the CLP program as a Foundation (now known as the CLFP Foundation) endorsed by NEFA, NAELB, and ELFA"},{"company":"Eastern Association of Equipment Lessors (EAEL) - Board of Directors 1994 - 2003 including 1997 - 2001 as Vice President and member of the Executive Committee","responsibilities":"Miscellaneous committee responsibilities including Fall Expo Exhibitors Committee Chairman (twice), Fall Expo Conference Chairman, Nominating Committee Chairman (three years), Annual Conference Committee, Chapter Committee member, Technology Committee member"},{"company":"United Association of Equipment Leasing/Western Association of Equipment Lessors (UAEL)","responsibilities":"Committee membership included Annual Conference Exhibitor Committee Chair, Ethic Committee Vice Chair, CLP Committee Funders Special Interest Group Committee"},{"company":"Leasing News - Advisory Board member 2001 - 2003","responsibilities":"Daily industry-wide internet newsletter"}]}

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	var _experience = __webpack_require__(378);
	
	__webpack_require__(277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['experience', 'memberships', 'testimonials'];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'experience-hero' },
	      _react2.default.createElement('div', { className: 'experience-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'experience-title' },
	      'Steven B. Geller, CLFP'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'experience-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'experience', current: 'experience' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'experience' },
	        _react2.default.createElement(
	          'div',
	          { className: 'experience-subtitle' },
	          'Professional Experience'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'experience-bullets' },
	          _experience.experience.map(function (expObj, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i, className: 'experience-bullet' },
	              expObj.company,
	              expObj.description && _react2.default.createElement(
	                'ul',
	                { className: 'nested-experience-bullets' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'nested-experience-bullet' },
	                  expObj.description
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'achievements' },
	        _react2.default.createElement(
	          'div',
	          { className: 'achievements-title' },
	          'Professional Achievements and Industry Designations'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'achievements-bullets' },
	          _experience.achievements.map(function (achObj, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i, className: 'achievements-bullet' },
	              achObj.company,
	              _react2.default.createElement(
	                'ul',
	                { className: 'nested-achievements-bullets' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'nested-achievements-bullet' },
	                  achObj.responsibilities
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-experience-index-js-e076193e4d435c714130.js